import React, { useEffect, useState } from 'react';
import { ThemeProvider as OriginalThemeProvider } from 'styled-components';

export const adminTheme = () => {
  const { primary_color, secondary_color, sidebar_color, logo_url, sidebar_text_color } = { ...window.settings };
  return {
    colour: {
      primary: primary_color,
      secondary: secondary_color,
      sidebar: sidebar_color,
      sidebarLinks: sidebar_text_color
    },
    fonts: {
      fontSize: {
        pageTitle: '24px',
      },
      fontWeight: {
        pageTitle: '600',
      },
    },
    logo: logo_url
  };
}

export const themeToSettings = ({ colour, fonts, logo }) => ({
  primary_color: colour.primary,
  secondary_color: colour.secondary,
  sidebar_color: colour.sidebar,
  sidebar_text_color: colour.sidebarLinks,
  logo_url: logo
})

export const themeMappings = {
  primary: 'primary_color',
  secondary: 'secondary_color',
  sidebar: 'sidebar_color',
  sidebarLinks: 'sidebar_text_color',
  logo: 'logo_url'
}

const ThemeProvider = ({ children }) => {
  return (
    <OriginalThemeProvider theme={adminTheme()}>
      {children}
    </OriginalThemeProvider>
  );
};

export default ThemeProvider
